import { createSelector } from '@reduxjs/toolkit';

import { GlobalState } from '@/redux/store';

import { RelatedSuggestions, SearchSuggestion } from './searchSuggestions.types';

const searchSuggestionsSlice = (state: GlobalState) => state.searchSuggestions;

export const getSearchSuggestions = createSelector(
    searchSuggestionsSlice,
    (uiSearchSuggestions): RelatedSuggestions[] => {
        const uniqueHousesMap = new Map<string, SearchSuggestion>();
        const uniqueItemsMap = new Map<string, SearchSuggestion>();

        uiSearchSuggestions.suggestions.forEach((result) => {
            if (result.label === 'Auction Houses') {
                return;
            }

            const uniqueKey = `${result.houseId || 0}-${result.label}-${result.value}`;

            if (result.houseId) {
                uniqueHousesMap.set(uniqueKey, result);
            } else {
                uniqueItemsMap.set(uniqueKey, result);
            }
        });

        const suggestions: RelatedSuggestions[] = [
            {
                suggestions: Array.from(uniqueItemsMap.values()),
                title: '',
            },
        ];

        if (uniqueHousesMap.size > 0) {
            suggestions.push({
                suggestions: Array.from(uniqueHousesMap.values()),
                title: 'Auction Houses',
            });
        }
        return suggestions;
    }
);

export const getSecondarySearchSuggestions = createSelector(searchSuggestionsSlice, (uiSearchSuggestions) => {
    const uniqueHousesMap = new Map<string, SearchSuggestion>();
    const uniqueSuggestionsMap = new Map<string, SearchSuggestion>();

    uiSearchSuggestions.secondarySuggestions.forEach((result) => {
        if (result.label === 'Auction Houses') {
            return;
        }

        const uniqueKey = `${result.houseId || 0}-${result.label}-${result.value}`;

        if (result.houseId) {
            uniqueHousesMap.set(uniqueKey, result);
        } else {
            uniqueSuggestionsMap.set(uniqueKey, result);
        }
    });

    return {
        houses: Array.from(uniqueHousesMap.values()),
        suggestions: Array.from(uniqueSuggestionsMap.values()),
    };
});
